var React = require('react');

function It (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#4caf50","d":"M0 0h100v300H0z","key":0}),React.createElement("path",{"fill":"red","d":"M200 0h100v300H200z","key":1}),React.createElement("path",{"fill":"#fff","d":"M100 0h100v300H100z","key":2})]);
}

It.defaultProps = {"viewBox":"0 0 300 300"};

module.exports = It;

It.default = It;
